// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/global.css */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #13141C;
  color: #FFFFFF;
  font-family: 'Inter', sans-serif;
}

/* Mobile table styles */
@media (max-width: 600px) {
  .MuiTableCell-root {
    padding: 12px 8px !important;
  }

  .MuiTableContainer-root {
    border-radius: 12px;
    overflow: hidden;
  }

  .MuiTableRow-root {
    background-color: #1A1B25;
  }

  .MuiTableCell-head {
    background-color: #1A1B25 !important;
    font-weight: 600 !important;
  }
}

/* Scrollbar styles */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #1A1B25;
}

::-webkit-scrollbar-thumb {
  background: #38F2AF;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #2bd994;
}

/* frontend/src/global.css */
/* Add these styles to your existing global.css */

/* Mobile-friendly tables */
@media (max-width: 600px) {
  .responsive-table {
    display: block;
    width: 100%;
  }

  .responsive-table tbody {
    display: block;
    width: 100%;
  }

  .responsive-table tr {
    display: block;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(224, 224, 224, 0.2);
  }

  .responsive-table td {
    display: flex;
    padding: 0.5rem 0;
    border: none;
    align-items: center;
    justify-content: space-between;
  }

  .responsive-table td:before {
    content: attr(data-label);
    font-weight: 600;
    margin-right: 1rem;
  }
}

/* Better scrolling on mobile */
* {
  -webkit-overflow-scrolling: touch;
}

/* Prevent horizontal overflow */
.MuiBox-root {
  max-width: 100%;
}

/* Better touch targets on mobile */
@media (max-width: 600px) {
  .MuiButtonBase-root {
    min-height: 44px;
  }

  .MuiIconButton-root {
    padding: 12px;
  }
}

.grecaptcha-badge {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;EAC7B;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B,iDAAiD;;AAEjD,2BAA2B;AAC3B;EACE;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,iDAAiD;EACnD;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* frontend/src/global.css */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background-color: #13141C;\n  color: #FFFFFF;\n  font-family: 'Inter', sans-serif;\n}\n\n/* Mobile table styles */\n@media (max-width: 600px) {\n  .MuiTableCell-root {\n    padding: 12px 8px !important;\n  }\n\n  .MuiTableContainer-root {\n    border-radius: 12px;\n    overflow: hidden;\n  }\n\n  .MuiTableRow-root {\n    background-color: #1A1B25;\n  }\n\n  .MuiTableCell-head {\n    background-color: #1A1B25 !important;\n    font-weight: 600 !important;\n  }\n}\n\n/* Scrollbar styles */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #1A1B25;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #38F2AF;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #2bd994;\n}\n\n/* frontend/src/global.css */\n/* Add these styles to your existing global.css */\n\n/* Mobile-friendly tables */\n@media (max-width: 600px) {\n  .responsive-table {\n    display: block;\n    width: 100%;\n  }\n\n  .responsive-table tbody {\n    display: block;\n    width: 100%;\n  }\n\n  .responsive-table tr {\n    display: block;\n    margin-bottom: 1rem;\n    border-bottom: 1px solid rgba(224, 224, 224, 0.2);\n  }\n\n  .responsive-table td {\n    display: flex;\n    padding: 0.5rem 0;\n    border: none;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .responsive-table td:before {\n    content: attr(data-label);\n    font-weight: 600;\n    margin-right: 1rem;\n  }\n}\n\n/* Better scrolling on mobile */\n* {\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Prevent horizontal overflow */\n.MuiBox-root {\n  max-width: 100%;\n}\n\n/* Better touch targets on mobile */\n@media (max-width: 600px) {\n  .MuiButtonBase-root {\n    min-height: 44px;\n  }\n\n  .MuiIconButton-root {\n    padding: 12px;\n  }\n}\n\n.grecaptcha-badge {\n  visibility: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
